import { ActivityType } from 'constants/activities';

export const ACTIVITIES_SORT_ID = 'activityDateTime';

export const ActivitiesTab = {
  ALL: 'all',
  EMAILS: 'emails',
  CALLS: 'calls',
  INTERNAL_CHAT: 'internal chat',
};

export const CallTypes = {
  INBOUND: 'Inbound',
  OUTBOUND: 'Outbound',
  OUTBOUND_ASSIGNED: 'OutboundAssigned',
  OUTBOUND_FOLLOW_UP: 'OutboundFollowUp',
  OUTBOUND_LEAD: 'OutboundLead',
};

// ContactActivity aggregates linked contacts' calls/meetings/tasks + notes onto
// the loan feed (A3 / DEV-4723). Always requested alongside CommonUpdate on the
// All tab; the loan-side handler composes it read-time from CRM link tables.
export const DEFAULT_FILTER_TYPES = [ActivityType.COMMON_UPDATE, ActivityType.CONTACT_ACTIVITY];

export const ActivitiesGroup = {
  COMMUNICATION: 'Communication',
  UPDATES: 'Updates',
};

export const ActivityTabToType = {
  [ActivitiesTab.EMAILS]: ActivityType.EMAIL,
  [ActivitiesTab.CALLS]: ActivityType.CALL,
};

export const EmailStatus = {
  SENT: 'Sent',
  OPENED: 'Opened',
  CLICKED: 'Clicked',
  FORWARDED: 'Forwarded',
  REPLIED: 'Replied',
  RECEIVED: 'Received',
};

const CallOutcome = {
  BUSY: 'BUSY',
  CONNECTED: 'CONNECTED',
  LIVE_MESSAGE: 'LIVE_MESSAGE',
  VOICEMAIL: 'VOICEMAIL',
  NO_ANSWER: 'NO_ANSWER',
  WRONG_NUMBER: 'WRONG_NUMBER',
  HANG_UP: 'HangUp',
  INVALID_NUMBER: 'InvalidNumber',
};

export const callOutcomeOptions = [
  { name: 'Busy', value: CallOutcome.BUSY },
  { name: 'Connected', value: CallOutcome.CONNECTED },
  { name: 'Left live message', value: CallOutcome.LIVE_MESSAGE },
  { name: 'Left voicemail', value: CallOutcome.VOICEMAIL },
  { name: 'No answer', value: CallOutcome.NO_ANSWER },
  { name: 'Wrong number', value: CallOutcome.WRONG_NUMBER },
  { name: 'Hang up', value: CallOutcome.HANG_UP },
  { name: 'Invalid number', value: CallOutcome.INVALID_NUMBER },
];

export const ChromeExtensionRequestType = {
  START_CALL: 'START_CALL',
};

export const WhiteColorVariations = [
  'rgb(255, 255, 255)',
  'rgba(255, 255, 255, 1)',
  'white',
  '#ffffff',
  '#fff',
];

export const BlackColorVariations = ['rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'black', '#000000'];

export const DisallowedEmailFileTypes = [
  'ade',
  'adp',
  'apk',
  'appx',
  'appxbundle',
  'bat',
  'cab',
  'chm',
  'cmd',
  'com',
  'cpl',
  'diagcab',
  'diagcfg',
  'diagpack',
  'dll',
  'dmg',
  'ex',
  'ex_',
  'exe',
  'hta',
  'img',
  'ins',
  'iso',
  'isp',
  'jar',
  'jnlp',
  'js',
  'jse',
  'lib',
  'lnk',
  'mde',
  'msc',
  'msi',
  'msix',
  'msixbundle',
  'msp',
  'mst',
  'nsh',
  'pif',
  'ps1',
  'scr',
  'sct',
  'shb',
  'sys',
  'vb',
  'vbe',
  'vbs',
  'vhd',
  'vxd',
  'wsc',
  'wsf',
  'wsh',
  'xll',
  // archives
  'ace',
  'arj',
  'bz2',
  'gz',
  'jgz',
  'lha',
  'lzh',
  'rar',
  'sit',
  'tar',
  'tar.bz2',
  'tar.gz',
  'tbz',
  'tgz',
  'wim',
  'xz',
  'z',
  'zip',
  '7z',
];

export const DisallowedFileSymbolsRegexp = /[\\/:?*"<>|&%#=[\]{}`]/;
